// Consumers build links as `${basePath}/${orgIntegrationId}`, so these must never end in a slash.
export const INTEGRATION_SETTINGS_BASE_PATH = '/settings/integrations'
export const PUBLIC_API_OAUTH_BASE_PATH = '/settings/api/oauth'

export type IntegrationSettingsBasePath = typeof INTEGRATION_SETTINGS_BASE_PATH | typeof PUBLIC_API_OAUTH_BASE_PATH
